window.addEventListener("pageshow", (event) => {
  if (event.persisted || window.performance.navigation.type === 2) {
    location.reload();
  }
});

document.addEventListener("DOMContentLoaded", function() {
  let cartSuccessTimeout = null;
  
  function selectAddToCartButton(buttonClass, parentClass) {
    parentTag = document.querySelectorAll(parentClass);
    parentTag.forEach((parent) => {
      const addToCartButton = parent.querySelector(buttonClass);
      addToCartButton.addEventListener("click", (event) => {
        // if (addToCartButton.classList.contains("disabled")) {
        //   return;
        // }
        const id = addToCartButton.getAttribute("data-product-id");
        // addToCartButton.classList.add("disabled");
        // const buttonContainer = parent.querySelector(".crt_btn");
        // const availability = parseInt(buttonContainer.getAttribute("data-item-availabilty"));
        // const cartCount = parseInt(buttonContainer.getAttribute("data-item-cart-count"));
        const addQuantity = parseInt(parent.querySelector(".add-quantity").value);
        // let cartErrorTimeout = null;
        // if (availability - cartCount >= addQuantity) {
          // const finalCartCount = cartCount + addQuantity;
          addItemToCart(id, addQuantity, addToCartButton, parent, cartSuccessTimeout);
          // buttonContainer.setAttribute("data-item-cart-count", finalCartCount);
        // }
        // else {
          // clearTimeout(cartSuccessTimeout);
          // parent.querySelector("#loadingIcon").style.display = "none";
          // parent.querySelector(".cart-success").style.display = "none";
          // parent.querySelector(".cart-error").style.display = "block";
          // cartErrorTimeout = setTimeout(() => {
            // parent.querySelector(".cart-error").style.display = "none";
          // }, 2000);
        // }
      });
    });
  }
  
  function updateCartCount(quantity) {
    const count = document.getElementById("cart-count");
    count.textContent = parseInt(count.textContent) + quantity;
  }

  // async function addItemToCart(id, quantity, addToCartButton, parent, cartErrorTimeout, cartSuccessTimeout) {
  async function addItemToCart(id, quantity, addToCartButton, parent, cartSuccessTimeout) {
    // clearTimeout(cartErrorTimeout);
    clearTimeout(cartSuccessTimeout);
    // parent.querySelector(".cart-error").style.display = "none";
    parent.querySelector(".cart-success").style.display = "none";
    parent.querySelector("#loadingIcon").style.setProperty("display", "block", "important");
    let data = {
      id: id,
      quantity: quantity
    };
    await fetch("/cart/add", {
      method: "post",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    // clearTimeout(cartErrorTimeout);
     clearTimeout(cartSuccessTimeout);
    // parent.querySelector(".cart-error").style.display = "none";
    parent.querySelector("#loadingIcon").style.display = "none";
    parent.querySelector(".cart-success").style.display = "none";
    parent.querySelector(".cart-success").style.display = "block";
    cartSuccessTimeout = setTimeout(() => {
      parent.querySelector(".cart-success").style.display = "none";
    }, 2000);
    updateCartCount(quantity);
    // addToCartButton.classList.remove("disabled");
  }
  
  if (document.querySelector(".add_to_crt_btn")) {
    if (document.querySelector(".prodct_desc")) {
      selectAddToCartButton(".add_to_crt_btn", ".prodct_desc");
    }
    else if (document.querySelector(".product_card")) {
      selectAddToCartButton(".add_to_crt_btn", ".product_card");
    }
  }
  
  let searchBtn = document.querySelector('.search_btn');
  let formModal = document.querySelector('.search_modal');
  let formCloseBtn = document.querySelector('.form_close_btn');
  
  searchBtn.addEventListener("click", function (e) {
    e.preventDefault();
    formModal.classList.toggle('show');
  });
  formCloseBtn.addEventListener('click', function (e) {
    e.preventDefault();
    formModal.classList.remove('show')
  });

  // Popup Modal JS Script start for regular customers
  
  // session storage start
  const showPopup = () => {
    if (document.getElementById('newpopup')) {
      document.getElementById('newpopup').style.display = 'flex';
    }
  };

  const closePopup = () => {
    // alert("hello");
    if (document.getElementById('newpopup')) {
      document.getElementById('newpopup').style.display = 'none';
      sessionStorage.setItem('popupLastClosed', new Date().getTime());
    }
  };

  const shouldShowPopup = () => {
    const now = new Date().getTime();
    const threeHours = 3 * 60 * 60 * 1000; // 3 hours in milliseconds
    let lastClosed = sessionStorage.getItem('popupLastClosed');
    // Check if last closed time exists and if 3 hours have passed since then
    return !lastClosed || (now - lastClosed) > threeHours;
  };

  let lastClosed = sessionStorage.getItem('popupLastClosed');
  if (lastClosed) {
    var popupLastClosed_check = true;
  }
  else {
    var popupLastClosed_check = false;
  }
  // Check the current date and show popup if within range and meets time criteria
  const today = new Date();
  const currentGMT = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), today.getUTCHours(), today.getUTCMinutes(), today.getUTCSeconds()));
  const startDate = new Date(Date.UTC(2025, 0, 22, 12, 30, 0, 0));
  const endDate = new Date(Date.UTC(2124, 11, 31, 23, 59, 0, 0));

  const discountType = "order";
  
  if (today >= startDate && today <= endDate){
    if (popupLastClosed_check == false) {
      setTimeout(() => {
        showPopup();
      }, 8000);
    }
    if (discountType == "product") {
      if (document.getElementById('new_price')) {
        document.getElementById('new_price').style.display = 'flex';
      }
    }
    else {
      if (document.getElementById('dflt_price')) {
        document.getElementById('dflt_price').style.display = 'flex';
      }
    }
    const announcement_bar = document.getElementById('hdr_ancmnt');
    if (announcement_bar) {
      announcement_bar.style.display = 'block';
    }
  }
    
  else {
    if (document.getElementById('dflt_price')) {
      document.getElementById('dflt_price').style.display = 'flex';
    }
  }

  // if (today >= startDate && today <= endDate && shouldShowPopup()) {
  //   showPopup();
  // }
  
  

  if (document.getElementById("ofr_mdl_close_btn")) {
    document.getElementById("ofr_mdl_close_btn").addEventListener('click', function() {
      closePopup();
    });
  }

  if (document.getElementById("ofr_mdl_shop_btn")) {
    document.getElementById("ofr_mdl_shop_btn").addEventListener('click', function() {
      closePopup();
    });
  }
  
  // session storage end
  
  // Popup Modal JS Script end for regular customers

  // Show hide password

  function showHidePassword (eyeOpen, eyeClosed, passwordField) {
    passwordField.addEventListener("input", function () {
      if (passwordField.value.length != 0) {
        if (passwordField.type == "text") {
          eyeOpen.style.display = "block";
          eyeClosed.style.display = "none";
        }
        else {
          eyeOpen.style.display = "none";
          eyeClosed.style.display = "block";
        }
      }
      else {
        passwordField.type = "password";
        eyeOpen.style.display = "none";
        eyeClosed.style.display = "none";
      }
    });
    
    eyeOpen.addEventListener("click", function () {
      passwordField.type = "password";
      eyeOpen.style.display = "none";
      eyeClosed.style.display = "block";
    });

    eyeClosed.addEventListener("click", function () {
      passwordField.type = "text";
      eyeOpen.style.display = "block";
      eyeClosed.style.display = "none";
    });
  }

  let eyeOpen = document.getElementById("eye-open");
  let eyeClosed = document.getElementById("eye-closed");
  if (eyeOpen && eyeClosed) {
    let passwordField = null;
    if (document.getElementById("CustomerPassword")) {
      passwordField = document.getElementById("CustomerPassword");
    }
    else if (document.getElementById("RegisterForm-password")) {
      passwordField = document.getElementById("RegisterForm-password");
    }
    else {
      passwordField = document.getElementById("password");
    }
    showHidePassword(eyeOpen, eyeClosed, passwordField);
  }

  eyeOpen = document.getElementById("eye-open2");
  eyeClosed = document.getElementById("eye-closed2");
  if (eyeOpen && eyeClosed) {
    let passwordField = document.getElementById("password_confirmation");
    showHidePassword(eyeOpen, eyeClosed, passwordField);
  }

  // Show hide password

});
